/** `play()` rejects with this when a pause or a new source interrupts it. */
export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}
